import type { GetEntitiesByFpIdMatchSignalsResponse, MatchLevel } from '@onefootprint/request-types/dashboard';

type SignalShortInfoType = {
  matchLevel: MatchLevel;
  description: string;
  reasonCode: string;
};

type TransformedMatchSignalDataType = {
  attribute: string;
  matchLevel: MatchLevel;
  signals: SignalShortInfoType[];
};

const filterUniqueSignals = (signals: SignalShortInfoType[]) => {
  const descriptions = new Set<string>();
  return signals.filter(signal => {
    if (descriptions.has(signal.description)) {
      return false;
    }
    descriptions.add(signal.description);
    return true;
  });
};

const transformResponse = (data: GetEntitiesByFpIdMatchSignalsResponse) => {
  const dataArray = Object.entries(data);
  const transformedData: TransformedMatchSignalDataType[] = [];

  dataArray.forEach(([attribute, signalsAndLevel]) => {
    if (signalsAndLevel) {
      const { matchLevel, signals } = signalsAndLevel;
      const signalInfo: SignalShortInfoType[] = [];
      signals.forEach(signal => {
        const { description, matchLevel: signalMatchLevel, reasonCode } = signal;
        signalInfo.push({
          matchLevel: signalMatchLevel,
          description,
          reasonCode,
        });
      });
      const dedupedSignals = filterUniqueSignals(signalInfo);
      transformedData.push({
        attribute,
        matchLevel,
        signals: dedupedSignals,
      });
    }
  });

  return transformedData;
};

export type { SignalShortInfoType, TransformedMatchSignalDataType };
export default transformResponse;
